import {AddAccessSwitch} from './AddAccessSwitch';
import {AddGeneric} from './AddGeneric';
import {AddLeaf} from './AddLeaf';
import {Clone} from './Clone';
import {Delete} from './Delete';
import {GenerateSummary} from './GenerateSummary';
import {ManageLinks} from './ManageLinks';
import {ManageMultipleLinks} from './ManageMultipleLinks';
import {RemoveLinks} from './RemoveLinks';
import {Properties} from './Properties';
import {Redo} from './Redo';
import {Undo} from './Undo';

export default [
  [AddLeaf, AddAccessSwitch, AddGeneric],
  [ManageLinks, ManageMultipleLinks, RemoveLinks, Clone, Properties, Delete],
  [Undo, Redo],
  [GenerateSummary]
];
